/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import { Grid, Paper, Typography, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import type { UserListItem } from '../../interfaces/IWarehouseForm'
import { useLang } from '~/hooks/useLang'

interface ManagersListProps {
  readonly managersList: readonly UserListItem[]
  readonly onRemove: (userId: number) => void
}

export default function ManagersList({
  managersList,
  onRemove,
}: ManagersListProps) {
  const { translate } = useLang()


  if (!managersList || managersList.length === 0) {
    return (
      <Grid item xs={12}>
        <Typography variant="body2" color="text.secondary">
          {translate('No managers added yet')}
        </Typography>
      </Grid>
    )
  }
  return (
    <>
      {managersList
        .filter((manager) => manager && manager.id)
        .map((manager) => (
        <Grid item xs={6} key={manager.id}>
          <Paper
            elevation={1}
            sx={{
              p: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="body1">
              {manager?.registration ? `[${manager?.registration}]` : ''} {manager?.representation_name || manager?.name || ''}
            </Typography>
            <IconButton
              color="error"
              onClick={() => onRemove(manager.id)}
              aria-label={translate('Remove manager')}
            >
              <DeleteIcon />
            </IconButton>
          </Paper>
        </Grid>
      ))}
    </>
  )
}
